import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/App';
import io from 'socket.io-client';
import { BrowserRouter as Router } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
const socket = io(
  process.env.NODE_ENV === 'production'
    ?  null //'https://pokerstream.app/socket.io/' // Production URL
    : 'http://localhost:4001'   // Development URL
);

// Initialize the Facebook SDK
window.fbAsyncInit = function() {
  window.FB.init({
    appId: process.env.NODE_ENV === 'production' ? 1248465185231194 : 1760947784823267,
    cookie: true,
    xfbml: true,
    version: 'v12.0',
  });

  // Additional SDK configuration or event handling can go here
};

// Load the SDK asynchronously
(function(d, s, id) {
  var js, fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s); js.id = id;
  // js.src = "https://connect.facebook.net/en_US/sdk.js#version=v2.2&appId=1248465185231194&xfbml=true&autoLogAppEvents=true"
  js.src = "https://connect.facebook.net/en_US/sdk.js";
            
  fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));

root.render(
  <React.StrictMode>
    <Router>
      <App 
        socket = { socket }
      />
    </Router>
  </React.StrictMode>
);
